import axios from 'axios';

const state = {
	affiliates: [],
	// affiliato selezionato dalla lista, usato dal dialog di modifica
	selected: {},
	// elenco ridotto { _id, name, code } per i select
	options: [],
};

const getters = {
	getAffiliates: state => {
		return state.affiliates;
	},
	getSelected: state => {
		return state.selected;
	},
	getOptions: state => {
		return state.options;
	},
};

const authHeaders = context => ({
	headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
});

const actions = {
	// Lista completa degli affiliati (solo SuperAdmin), sezione Gestione > Affiliati
	asyncFetchAffiliates: context => {
		let url = 'affiliates/all';
		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, authHeaders(context))
			.then(res => {
				context.commit('setAffiliates', res.data.data);
			})
			.catch(err => {
				if (err.response && err.response.status === 401) {
					context.commit('profile/setLogout', {}, { root: true });
				}
				throw err;
			});
	},
	// Elenco ridotto per il select "Affiliato" nella scheda profilo
	fetchOptions: context => {
		let url = 'affiliates/options';
		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, authHeaders(context))
			.then(res => {
				context.commit('setOptions', res.data.data);
				return res.data.data;
			})
			.catch(err => {
				if (err.response && err.response.status === 401) {
					context.commit('profile/setLogout', {}, { root: true });
				}
				throw err;
			});
	},
	createAffiliate: (context, payload) => {
		let url = 'affiliates/store';
		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
				.then(res => {
					context.dispatch('asyncFetchAffiliates');
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
	updateAffiliate: (context, payload) => {
		let url = 'affiliates/update';
		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
				.then(res => {
					context.dispatch('asyncFetchAffiliates');
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
	// Aggiornamento rapido dello stato attivo/non attivo (PATCH)
	patchActive: (context, payload) => {
		let url = 'affiliates/active';
		return new Promise((resolve, reject) => {
			axios
				.patch(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
				.then(res => {
					context.commit('setActive', { _id: payload._id, active: payload.active });
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
	deleteAffiliate: (context, payload) => {
		let url = 'affiliates/delete';
		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, authHeaders(context))
				.then(res => {
					context.commit('removeAffiliate', payload._id);
					resolve(res.data);
				})
				.catch(err => {
					if (err.response && err.response.status === 401) {
						context.commit('profile/setLogout', {}, { root: true });
					}
					reject(err);
				});
		});
	},
};

const mutations = {
	setAffiliates: (state, value) => {
		state.affiliates = value;
	},
	setSelected: (state, value) => {
		state.selected = value || {};
	},
	setOptions: (state, value) => {
		state.options = value || [];
	},
	setActive: (state, { _id, active }) => {
		const affiliate = state.affiliates.find(a => a._id === _id);
		if (affiliate) {
			affiliate.active = active;
		}
	},
	removeAffiliate: (state, _id) => {
		state.affiliates = state.affiliates.filter(a => a._id !== _id);
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
